/* eslint-disable no-underscore-dangle */
export default function getRoute(sources, drops) {
  let from = sources[0].address.display_reference_name || sources[0].address.city || '';
  let to = '';
  let sourceToolTipText = '';
  let finalToolTipText = '';
  let multidropCities = '';
  const gateReferenceName = [];
  const destinationGateIds = [...new Set(drops.map(destination => destination.gate_id && destination.gate_id.toString()))];
  const destinationGates = destinationGateIds.reduce((acc, gateId) => {
    const gates = drops.reduce((previous, dest) => {
      const matched = (dest.address.gates || []).filter(gate => gate._id.toString() === gateId);
      return [...previous, ...matched];
    }, []);
    return [...acc, ...gates];
  }, []);
  if (sources[0].type === 1 || sources[0].type === 3) {
    const gateIdArr = [...new Set(sources.map(source => source.gate_id && source.gate_id.toString()))];
    const gates = sources[0].address.gates.filter(gate => gateIdArr.includes(gate._id.toString()));
    gates.forEach((gate) => {
      if (gate.display_reference_name) {
        gateReferenceName.push(gate.display_reference_name);
      }
    });
    if (gateReferenceName.length) {
      if (gateReferenceName.length > 1) {
        from = `${gateReferenceName[0]}+${gateReferenceName.length - 1}`;
        sourceToolTipText = gateReferenceName.join(', ');
      } else {
        from = gateReferenceName[0];
        sourceToolTipText = from;
      }
    }
  }
  const destinations = [];
  drops.forEach((item) => {
    const i = destinations.findIndex(x => x.location_id === item.location_id);
    if (i <= -1) {
      destinations.push(item);
    }
  });
  const [destinationGateRef] = destinationGates.filter(ref => ref.display_reference_name);
  if (destinations && destinations.length > 0) {
    if (destinations.length > 1) {
      to = 'Multidrop';
      if (destinationGateRef) {
        multidropCities = (destinationGateRef && destinationGateRef.display_reference_name);
      } else {
        multidropCities = destinations.map(dest => (dest.address.display_reference_name || dest.address.city || dest.address.name)).join(', ');
      }
    } else {
      to = destinations[0].address.display_reference_name || destinations[0].address.city || destinations[0].address.name;
    }
  }
  if (to === 'Multidrop' && sourceToolTipText) {
    finalToolTipText = `${sourceToolTipText} - ${multidropCities}`;
  } else if (to === 'Multidrop') {
    finalToolTipText = `${sourceToolTipText} -  ${multidropCities}`;
  } else if (gateReferenceName.length > 1) {
    finalToolTipText = `${sourceToolTipText} -  ${to}`;
  } else {
    finalToolTipText = '';
  }
  return { from, to, value: from.concat(' - ', to), tooltipText: finalToolTipText };
}
